const endpoints = {
  listMailingRules: (): string => `mailing-rule`,
};

export default endpoints;
